"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = descToTypescript;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var arrayFormat = function arrayFormat(array) {
  return array.map(function (propType) {
    return propTypeFormat(propType);
  });
};

var shapeFormat = function shapeFormat(shape) {
  var props = Object.keys(shape).map(function (key) {
    var value = shape[key];
    var valueFormat;

    if (value.type && (value.type === 'arrayOf' || value.type === 'oneOfType' || value.type === 'oneOf') && Array.isArray(value.args)) {
      valueFormat = "".concat(propTypeFormat(value));
    } else if (value.type === 'shape') {
      valueFormat = "".concat(propTypeFormat(value));
    } else {
      valueFormat = propTypeFormat(value);
    }

    return "".concat(key).concat(value.reactDesc && value.reactDesc.required ? '' : '?', ": ").concat(valueFormat);
  });
  return "{".concat(props.join(','), "}");
};

var propTypeFormat = function propTypeFormat(propType, joinWith) {
  var result;

  if (Array.isArray(propType)) {
    result = arrayFormat(propType).join(joinWith);
  } else if (typeof propType !== 'function' && propType.type) {
    switch (propType.type) {
      case 'array':
        result = 'any[]';
        break;

      case 'arrayOf':
        if (propType.args.type === 'oneOfType') {
          result = "(".concat(propTypeFormat(propType.args, ' | '), ")[]");
        } else {
          result = "".concat(propTypeFormat(propType.args, '\n'), "[]");
        }

        break;

      case 'bool':
        result = 'boolean';
        break;

      case 'func':
        result = '((...args: any[]) => any)';
        break;

      case 'node':
        result = 'React.ReactNode';
        break;

      case 'element':
        result = 'JSX.Element';
        break;

      case 'instanceOf':
        result = 'any';
        break;

      case 'symbol':
        result = 'any';
        break;

      case 'objectOf':
        result = "{ [key: string]: ".concat(propTypeFormat(propType.args), " }");
        break;

      case 'oneOf':
        result = propType.args.map(function (a) {
          return "\"".concat(a, "\"");
        }).join(' | ');
        break;

      case 'oneOfType':
        result = "".concat(propTypeFormat(propType.args, ' | '));
        break;

      case 'shape':
        result = "".concat(shapeFormat(propType.args));
        break;

      default:
        result = "".concat(propType.type);
        break;
    }
  } else {
    result = 'any';
  }

  return result;
};

var propTypeAsTypescript = function propTypeAsTypescript(propType, propName) {
  var documentation = _objectSpread(_objectSpread({}, propType.reactDesc), {}, {
    name: propName
  });

  documentation.format = propTypeFormat(propType);
  return documentation;
};

function descToTypescript(component) {
  var reactDesc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!component) {
    throw new Error('react-desc: component is required');
  }

  var documentation = _objectSpread({
    name: component.displayName || component.name
  }, reactDesc);

  if (reactDesc) {
    delete documentation.propTypes;

    if (reactDesc.propTypes) {
      var propTypes = [];
      Object.keys(reactDesc.propTypes).forEach(function (propName) {
        var propType = reactDesc.propTypes[propName];
        propTypes.push(propTypeAsTypescript(propType, propName));
      });

      if (propTypes.length > 0) {
        documentation.properties = propTypes;
      }
    }
  }

  return documentation;
}